module.exports = __webpack_public_path__ + "img/Pino-Dental-Dr-Raquel-Pino.b4fa3410.jpeg";